// ========================================================================
// Test component for Trace ID in error messages
// This component intentionally throws an error to test ErrorBoundary and Trace ID display
// To use: Add ?test-trace-id=yes to the URL
// ========================================================================

import { useEffect, useState } from 'react'

export const TraceIdTestTrigger = () => {
  const [shouldThrow, setShouldThrow] = useState(false)

  useEffect(() => {
    const testTraceId = new URLSearchParams(window.location.search).get('test-trace-id')
    if (testTraceId === 'yes') {
      // Delay slightly to ensure everything is mounted
      setTimeout(() => {
        setShouldThrow(true)
      }, 100)
    }
  }, [])

  if (shouldThrow) {
    throw new Error(
      'TEST ERROR: This is a test error to verify that Trace ID is displayed to users. ' +
        'You should see a trace ID in the error message.'
    )
  }

  return null
}
